import { z } from "zod";

export const VIZ_TYPES = ["kpi", "line", "bar", "area", "combo", "pie", "heatmap", "scatter", "treemap", "funnel", "table", "pivot"] as const;
export type VizType = (typeof VIZ_TYPES)[number];

/** When to pick each type. Shared by the built-in ask and the MCP server so they can't drift apart. */
export const VIZ_GUIDE =
  "kpi for a single number; line/area for trends over time; bar for categories; combo for one grouping with two or more metrics of different scale (first metric bars, the rest lines); " +
  "pie for share of a total across a few categories; treemap for share of a total across many categories or two nested groupings (summable metrics only); " +
  "heatmap for one metric across two groupings (e.g. day by hour); scatter for two metrics against each other, one point per value of the grouping (optional third metric sizes points); " +
  "funnel for two or more metrics that are successive stages of one population (each a subset of the one before), no groupings; " +
  "table for detail; pivot for two or more groupings as a cross-tab.";

export const VisualizationSchema = z.object({
  type: z.enum(VIZ_TYPES),
  config: z.record(z.string(), z.unknown()).default({}),
});
export type Visualization = z.infer<typeof VisualizationSchema>;
